import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/1.mp3"
export default function P1() {
    return (
        <MainLayout
            title="„Tam, gdzie konwalie – interaktywna opowieść o olędrach”"
            question=""
            audio={audio}
            answers={{
                ans1: "Dalej",
            }}
            links={{
                link1: PAGES.p2,
            }}
            content={<div>
                <p>
                    „Tam, gdzie konwalie – interaktywna opowieść o olędrach”
                </p>
                <p>
                    W Pacanowie kozy kują, w Zagórowie – gęsi. Tak przynajmniej obiło ci się o uszy. Bierzesz więc tobołek na plecy i wyruszasz w poszukiwaniu przygód.
                </p>
            </div>}
        />

    );
}